export const enventaConnector = {
  authentication: {
    connectorConfig_wsdl: "WSDL",
    connectorConfig_location: "Location / Endpunkt",
    connectorConfig_username: "Benutzername",
    connectorConfig_password: "Passwort",
    connectorConfig_tokenExpires: "Ablaufdatum des ContextToken (in Minuten)",
    connectorConfig_persistToken: "ContextToken speichern",
    connectorActionTestConnection: "Verbindung zur eNVenta-Instanz testen",
    connectorActionTestConnectionSuccess:
      "Verbindungsaufbau zur eNVenta-Instanz erfolreich",
    connectorActionTestConnectionError:
      "Fehler beim Verbindungsaufbau zur eNVenta-Instanz",
    connectorActionGetRequests: "Verfügbare Requests laden",
    connectorActionGetRequestsError: "Requests konnten nicht geladen werden",
    connectorActionGetRequestsSuccess: "Requests erfolreich geladen",
    connectorConfig_apiVersion: "API-Version der eNVenta-Instanz",
    version: "Konnektor-Version"
  },
  configuration: {
    request: "Request auswählen",
    connectorConfig_businessUnitId: "Geschäftseinheit des Mandanten",
    connectorConfig_languageId: "Sprach-Code",
    connectorConfig_options: "Weitere Optionen",
    connectorConfig_optionsValues: {
      key: "Schlüssel",
      value: "Wert"
    },
    dataInput: "Dateneingabe via",
    createRequestDataStructure: "Datenstruktur aus Request erstellen",
    createRequestDataStructureSuccess: "Datenstruktur erfolgreich angelegt",
    createRequestDataStructureError: "Fehler beim Erstellen der Datenstruktur"
  },
  input: {
    data: "Daten (Output-Variable)"
  },
  output: {
    createResponseDataStructure: "Datenstruktur aus Response erstellen",
    createResponseDataStructureError: "Fehler beim Erstellen der Datenstruktur",
    createResponseDataStructureSuccess: "Datenstruktur erfolgreich angelegt"
  }
};
